<template>
    <div>

        <form autocomplete="off" class="trax-form mb-4" v-show="!disabled && atpLaunchPermission && atpDafEditStatus">

            <trax-ui-input :placeholder="lang.polaris.procedure.title" col="md-3"
                v-model="form.name" :error="errors.name" required="1">
            </trax-ui-input>

            <trax-ui-select :placeholder="lang.polaris.procedure.urgence" col="md-3"
                v-model="form.priority_level_code" :error="errors.priority_level_code" 
                :options="priority_levels_select">
            </trax-ui-select>

            <trax-ui-input :placeholder="lang.polaris.procedure.problem_analysis" col="md-3"
                rows="10" v-model="form.description" :error="errors.description" required="1">
            </trax-ui-input>

        </form>

        <div class="pb-3" v-show="disabled || !atpLaunchPermission || !atpDafEditStatus">

            <trax-ui-html :placeholder="lang.polaris.procedure.title" 
                v-model="form.name" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.urgence" 
                v-model="priorityLevel" col="md-3">
            </trax-ui-html>

            <trax-ui-html :placeholder="lang.polaris.procedure.problem_analysis" 
                v-model="form.description" col="md-3">
            </trax-ui-html>
        </div>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-procedure-atp-daf-edit'},
            source: {default: '1'},
            target: {default: '2'}
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                priority_levels_select: data.priority_levels_select,
                priority_levels_names: data.priority_levels_names,
                form: {
                    name: '',
                    priority_level_code: 'next_meeting',
                    description: '',
                },
                errors: {},
                disabled: true,
                bus: this.$bus
            }
        },
        
        computed: {

            priorityLevel: function() {
                return this.priority_levels_names[this.form.priority_level_code];
            },

            atpLaunchPermission: function() {
                if (this.user.admin || this.user.permissions['procedure.write-atp']) return true;
                var userFunction = this.user.user_function;
                if (!userFunction) return false;
                return userFunction == 'training' || userFunction == 'training_op';
            },

            atpDafEditStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.bus.$on(this.id+'-updated', this.setData);
            this.bus.$on(this.id+'-'+this.source+'-save', this.saveData);
            this.bus.$on(this.id+'-errors', this.setErrors);
        },

        methods: {

            setData(procedure) {
                this.form.name = procedure.name;
                if (procedure.data.atp_launch) {
                    this.form.description = procedure.data.atp_launch.description;
                    if (procedure.data.atp_launch.priority_level_code)
                        this.form.priority_level_code = procedure.data.atp_launch.priority_level_code;
                }
                this.disabled = (procedure.data.atp_launch_submit != undefined);
            },

            saveData(data) {
                this.errors = {};
                data.name = this.form.name;
                data.data = { atp_launch: { 
                    description: this.form.description,
                    priority_level_code: this.form.priority_level_code,
                }};
                this.bus.$emit(this.id+'-'+this.target+'-save', data);
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    var errorNames = index.split('.');
                    var errorName = errorNames[errorNames.length-1];
                    my_errors[errorName] = errors[index];
                }
                this.errors = my_errors;
            }

        }
    }
</script>
